<template>
  <div class="time-sheet time-sheet-submit">
    <CCard class="filter">
      <div class="filter-title">
        {{ $t("commons.label_filter_title") }}
      </div>
      <div class="filter_hr"></div>
      <CRow>
        <CCol col="12" sm="6" lg="3" class="filter_month">
          <div>
            <div class="filter_month__title">
              {{ $t("commons.label_month") }}
            </div>
            <a-month-picker
              placeholder="MM/YYYY"
              size="large"
              :class="'month-picker__input'"
              v-model="searchData.month"
              :disabled-date="disableMonth"
              format="MM/YYYY"
              @change="search"
            >
              <template slot="suffixIcon">
                <img src="../../assets/img/calendar.svg" alt="" />
              </template>
            </a-month-picker>
          </div>
        </CCol>
        <CCol col="12" sm="6" lg="3" class="pr-0">
          <CButton @click="search" class="btn-search-timesheet">
            <img src="/img/icons/search-icon.svg" alt="" />
            {{ $t("label.search") }}
          </CButton>
        </CCol>
      </CRow>
    </CCard>
    <div class="table-list">
      <CCard>
        <CCardBody>
          <div class="option-table">
            <div class="page-title">Danh sách gửi remind</div>
          </div>
          <div class="table-responsive table-ecs-container">
            <table class="table table-content table-hover">
              <thead class="table-header">
                <tr>
                  <th width="130px">STT</th>
                  <th width="250px">Thời gian gửi</th>
                  <th class="200px">Số lượng</th>
                  <th width="200px" class="text-center">Thành công</th>
                  <th width="200px" class="text-center">Thất bại</th>
                  <th width="200px" class="text-center">Trạng thái</th>
                  <th class="text-center">Hoạt động</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <template
                  v-if="remindHistoryList && remindHistoryList.length > 0"
                >
                  <tr v-for="(data, index) in remindHistoryList" :key="index">
                    <td class="text-center">
                      {{ index + 1 }}
                    </td>
                    <td>{{ formatDate(data.remind_at) }}</td>
                    <td class="text-center">
                      {{ data.total }}
                    </td>
                    <td class="text-total text-center">
                      {{ data.success }}
                    </td>
                    <td class="text-center">
                      {{ data.failure }}
                    </td>
                    <td class="text-center">
                      <span class="text-success">Đã gửi</span>
                    </td>
                    <td class="text-total text-center">
                      <button
                        class="btn btn-outline-detail btn-sm mr-2"
                        @click="openModalList(data.id)"
                      >
                        Chi Tiết
                      </button>
                      <button
                        class="btn btn-outline-send btn-sm"
                        @click="openRemindModal(data.id)"
                      >
                        Gửi lại
                      </button>
                      <!-- <div class="btn-group">
                        <span
                          class="btn-detail"
                          @click="openModalList(data.remind_histories, data.id)"
                          >Chi tiết</span
                        >
                        <span>|</span>
                        <span
                          class="btn-remind"
                          @click="
                            openRemindModal(data.remind_histories, data.id)
                          "
                          >Gửi lại</span
                        >
                      </div> -->
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="13" class="text-center">
                      {{ $t("table.label_data_not_found") }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </CCardBody>
        <CPagination
          v-if="remindHistoryList"
          :activePage.sync="pagination.currentPage"
          :pages="pagination.totalPage"
          @update:activePage="fetchTimeSheetData"
          size="sm"
          align="center"
        />
      </CCard>
    </div>
    <a-modal
      class="remind-modal-list"
      :centered="true"
      v-model="isShowHistoryRemindModal"
      title="Danh sách các nhân viên được gửi remind"
      on-ok="closeHistoryRemindModal"
      :zIndex="1030"
      :closable="true"
      :destroyOnClose="true"
    >
      <template slot="footer">
        <a-button
          key="back"
          class="footer-btn close-btn"
          @click="closeHistoryRemindModal"
        >
          Đóng
        </a-button>
      </template>
      <template>
        <div class="modal-content-wrapper">
          <div class="modal-btn mb-2">
            <a-select
              class="modal-select"
              v-model="option"
              style="width: 150px"
              @change="handleChange"
              size="large"
            >
              <a-select-option value="all"> Tất cả </a-select-option>
              <a-select-option value="1"> Thành công </a-select-option>
              <a-select-option value="0"> Thất bại </a-select-option>
            </a-select>
            <a-button
              key="send"
              class="footer-btn confirm-btn ml-0"
              @click="openRemindModal()"
            >
              Gửi lại
            </a-button>
          </div>
          <div class="table-modal-wrapper">
            <!-- <table class="table-content">
              <thead class="table-header">
                <tr>
                  <th class="text-center">ID</th>
                  <th class="text-center">Họ và Tên</th>
                  <th class="text-center">Thời gian</th>
                  <th class="text-center">Trạng thái</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <template v-if="listData && listData.length > 0">
                  <tr v-for="item in listData" :key="item.key">
                    <td class="text-center">{{ item.employee_id }}</td>
                    <td class="text-center">
                      {{ item.account.name }}
                    </td>
                    <td class="text-center">
                      {{ formatDate(item.reminded_at) }}
                    </td>
                    <td class="text-center">
                      <span class="clr-success" v-if="item.success === 1"
                        >Thành công</span
                      >
                      <span class="clr-fail" v-else> Thất bại</span>
                    </td>
                  </tr>
                </template>

                <tr v-else>
                  <td colspan="6">
                    <a-empty :image="simpleImage" :description="description" />
                  </td>
                </tr>
              </tbody>
            </table> -->
            <div class="table--header">
              <table class="table-fixed">
                <thead class="table-header-fixed">
                  <tr>
                    <th width="10%" class="text-center">ID</th>
                    <th width="30%" class="text-center">Họ và Tên</th>
                    <th width="30%" class="text-center">Thời gian</th>
                    <th width="30%" class="text-center">Trạng thái</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="table--body">
              <table class="table-fixed">
                <tbody class="table-body-fixed">
                  <template
                    v-if="
                      remindEmployeeHistoryList &&
                      remindEmployeeHistoryList.length > 0
                    "
                  >
                    <tr
                      v-for="item in remindEmployeeHistoryList.filter(item => {
                        if (this.employeeFilter == 'all') {
                          return true;
                        } else {
                          return item.success == this.employeeFilter;
                        }
                      })"
                      :key="item.key"
                    >
                      <td width="10%" class="text-center">
                        {{ item.employee_id }}
                      </td>
                      <td width="30%" class="text-center">
                        {{ item.account.name }}
                      </td>
                      <td width="30%" class="text-center">
                        {{ formatDate(item.reminded_at) }}
                      </td>
                      <td width="30%" class="text-center">
                        <span class="text-success" v-if="item.success === 1"
                          >Thành công</span
                        >
                        <span class="text-fail" v-else> Thất bại</span>
                      </td>
                    </tr>
                  </template>

                  <tr v-else>
                    <td colspan="6">
                      <a-empty
                        :image="simpleImage"
                        :description="description"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </template>
    </a-modal>
    <a-modal
      class="remind-modal remind-history-modal"
      :centered="true"
      v-model="isShowRemindModal"
      title="Xác nhận gửi lại thông báo"
      on-ok="closeHistoryRemindModal"
      :zIndex="1035"
      :closable="true"
    >
      <template slot="footer">
        <a-button
          key="send"
          class="footer-btn confirm-btn ml-0"
          @click="resendRemind"
        >
          Xác nhận
        </a-button>
        <a-button
          key="back"
          class="footer-btn close-btn m-l-20"
          @click="closeRemindModal"
        >
          Đóng
        </a-button>
      </template>
      <template>
        <div class="modal-content-remind">
          <div class="remind-note">
            <div class="d-flex justify-content-center">
              <img src="../../assets/img/note.svg" class="mr-2" alt="" />
              <span>
                Hệ thống sẽ gửi lại thông báo tới
                {{ listDataRemind.length }} nhân sự đã gửi thất bại.
              </span>
            </div>

            <div class="remind-employee my-3">
              Những người trong danh sách sau sẽ nhận được tin nhắn:
            </div>
          </div>
          <div class="table-modal">
            <table class="table-content">
              <thead class="table-header">
                <tr>
                  <th class="text-center">ID</th>
                  <th class="text-center">Họ và Tên</th>
                </tr>
              </thead>
              <tbody class="table-body">
                <template v-if="listDataRemind && listDataRemind.length > 0">
                  <tr v-for="item in listDataRemind" :key="item.key">
                    <td class="text-center">{{ item.employee_id }}</td>
                    <td class="text-center">
                      {{ item.account.name }}
                    </td>
                  </tr>
                </template>

                <tr v-else>
                  <td colspan="6">
                    <a-empty :image="simpleImage" :description="description" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import { Empty } from "ant-design-vue";
import moment from "moment";

export default {
  name: "TimeSheetListSubmit",
  metaInfo() {
    return {
      title: this.$t("page_title.page_remind_history"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    // DatePickerFormFlex
  },
  data() {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      description: this.$t("table.label_data_not_found"),
      option: "all",
      searchData: {
        month: moment(),
        status: null,
        itemsPerPage: 10,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0,
        },
      },
      checkSubmit: true,
      listData: {},
      listDataRemind: {},
      allData: {},
      employeeFilter: "all",
      isShowHistoryRemindModal: false,
      isShowRemindModal: false,
      id: null,
    };
  },
  async created() {
    if (this.$route.params.month) {
      this.searchData.month = moment(this.$route.params.month);
    }
    this.fetchTimeSheetData();
  },
  computed: {
    ...mapGetters({
      remindHistoryList: "timeSheet/remindHistoryList",
      pagination: "timeSheet/pagination",
      listItemsPerPage: "commons/listItemsPerPage",
      remindEmployeeHistoryList: "timeSheet/remindEmployeeHistoryList",
    }),
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),

    disableMonth(current) {
      return current && current > moment().endOf("day");
    },

    async fetchTimeSheetData() {
      this.setLoading(true);
      await this.$store
        .dispatch("timeSheet/remindHistoryList", {
          ...this.pagination,
          status: this.searchData.status,
          month: moment(this.searchData.month).format("MM/YYYY"),
          perPage: this.searchData.itemsPerPage,
        })
        .then(() => {
          this.setLoading(false);
          this.searchData.paginate = this.pagination;
        })
        .catch(() => {
          this.setLoading(false);
        });
    },

    async search() {
      this.searchData.paginate.currentPage = 1;
      this.setLoading(true);
      try {
        await this.fetchTimeSheetData();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },

    async resendRemind() {
      this.setLoading(true);
      await this.$store.dispatch("timeSheet/resendUnsubmitRemindTimeSheet", {
        id: this.id,
        month: moment(this.searchData.month).format("MM/YYYY"),
      }).then(() => {
          let message = this.$t("popup.label_remind_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.isShowRemindModal = false;
          this.setLoading(false);
        }).catch(() => {
          let message = this.$t("popup.label_remind_fail");
          this.$toast(message, null, 2000, "b-toaster-top-center", "error");
          this.setLoading(false);
        });
      await this.fetchTimeSheetData();
      this.setLoading(false);
      this.isShowRemindModal = false;
      this.isShowHistoryRemindModal = false;
    },

    async openModalList(id) {
      this.isShowHistoryRemindModal = true;
      this.id = id;
      await this.$store.dispatch("timeSheet/employeeRemindHistoryList", { id });
    },

    async openRemindModal(id) {
      if (id) {
        this.id = id;
        await this.$store.dispatch("timeSheet/employeeRemindHistoryList", { id });
      }
      this.listDataRemind = {};
      this.listDataRemind = this.remindEmployeeHistoryList.filter((item) => item.success === 0);
      this.isShowRemindModal = true;
    },

    closeHistoryRemindModal() {
      this.isShowHistoryRemindModal = false;
    },

    closeRemindModal() {
      this.isShowRemindModal = false;
    },

    formatDate(date) {
      return moment(date).format("HH:mm DD/MM/YYYY");
    },

    handleChange(value) {
      this.employeeFilter = value;
    },
  },
};
</script>

<style lang="scss">
.time-sheet-submit {
  input,
  select {
    border-radius: 10px !important;
    width: 100%;
    height: 40px;
  }

  .ant-calendar-picker {
    width: 100%;

    .ant-input {
      border-radius: 10px !important;
      width: 100%;
    }
  }
}

.ant-modal-close {
  &:focus-visible,
  &:focus {
    outline: unset;
  }

  .ant-modal-close-icon {
    &:focus-visible,
    &:focus {
      outline: unset;
    }
  }
}

.ant-modal {
  max-width: 684px;
  width: 100% !important;

  .ant-modal-content {
    border-radius: 10px;
  }
}

.ant-modal-header {
  padding: 20px;
  background: #d2d6ff;
  border-bottom: 1px solid #3d4cdc;
  border-radius: 10px 10px 0 0;

  .ant-modal-title {
    color: #3d4cdc;
    font-weight: 700;
  }
}

.ant-modal-footer {
  border-top: none;
  display: flex;
  justify-content: center;
  padding-top: 0;
  padding-bottom: 20px;
  border-radius: 0 0 10px 10px;

  .footer-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 210px;
    width: 100%;
    font-weight: 700;
    font-size: 14px;
    border-radius: 10px;
    border: unset;
    height: 40px;

    img {
      margin-right: 5px;
    }
  }

  .m-l-20 {
    margin-left: 20px;
  }

  .close-btn {
    //border-color: #118fa6;
    color: #6f6f6f;
    background: #ececec;
  }

  .confirm-btn {
    background: #3d4cdc;
    color: #ffffff;
  }
}

.remind-modal-list {
  .ant-modal-body {
    padding: 20px;
    // max-width: 440px;
    width: 100%;
    margin: 0 auto;

    .modal-content-wrapper {
      border: none !important;

      .modal-btn {
        align-items: center;
        display: flex;
        justify-content: space-between;

        .modal-select {
          border-radius: 10px;
          .ant-select-selection--single {
            border-radius: 10px;
          }
        }

        .footer-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          max-width: 140px;
          width: 100%;
          font-weight: 700;
          font-size: 14px;
          border-radius: 10px;
          border: unset;
          height: 40px;
        }
        .confirm-btn {
          background: #3d4cdc;
          color: #ffffff;
        }
      }

      .table-modal-wrapper {
        border: 1px solid #dddddd;
        border-radius: 10px;

        .table--header {
          background: #eeeeee;
          overflow-y: scroll;
          border-top-left-radius: 9px;
          border-top-right-radius: 9px;
          &::-webkit-scrollbar {
            width: 4px;
            color: transparent;
          }

          .table-fixed {
            width: 100%;

            & th:not(:last-child),
            & td:not(:last-child) {
              border-right: 1px solid #dddddd;
            }

            .table-header-fixed {
              tr {
                th {
                  background: #eeeeee;
                  padding: 1em;
                  text-align: center;
                  font-style: normal;
                  font-weight: 700;
                  font-size: 14px;
                  line-height: 20px;
                  color: #303c54;
                }
              }
            }
          }
        }
        .table--body {
          border-top: 1px solid #dddddd;
          max-height: 300px;
          overflow-y: scroll;
          &::-webkit-scrollbar {
            width: 4px;
          }

          /* Track */
          &::-webkit-scrollbar-track {
            background: #eeeeee;
            border-radius: 0 5px 5px 0px;
          }

          /* Handle */
          &::-webkit-scrollbar-thumb {
            background: #ccc;
            border-radius: 5px;
          }

          /* Handle on hover */
          &::-webkit-scrollbar-thumb:hover {
            background: #555;
          }
          .table-fixed {
            width: 100%;

            & th:not(:last-child),
            & td:not(:last-child) {
              border-right: 1px solid #dddddd;
            }

            & > thead > tr:not(:last-child) > th,
            & > thead > tr:not(:last-child) > td,
            & > tbody > tr:not(:last-child) > th,
            & > tbody > tr:not(:last-child) > td,
            & > tfoot > tr:not(:last-child) > th,
            & > tfoot > tr:not(:last-child) > td,
            & > tr:not(:last-child) > td,
            & > tr:not(:last-child) > th,
            & > thead:not(:last-child),
            & > tbody:not(:last-child),
            & > tfoot:not(:last-child) {
              border-bottom: 1px solid #efefef;
            }
            .table-body-fixed {
              tr {
                td {
                  padding: 0.7em 0;
                  height: 45px;
                  font-style: normal;
                  font-weight: 400;
                  font-size: 14px;
                  line-height: 20px;
                  color: #303c54;
                  border: 1px solid #efefef;
                  vertical-align: baseline;
                  text-align: center;

                  .text-success {
                    color: #17a896;
                  }

                  .text-fail {
                    color: #f03d3e;
                  }
                }
              }
            }
          }
        }
      }

      .message-not-submit-success {
        color: #303c54;
        font-weight: 400;
      }

      .table-modal {
        width: 100%;
        max-height: 245px;
        overflow: auto;

        &::-webkit-scrollbar {
          width: 10px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
          background: #eeeeee;
          border-radius: 0 5px 5px 0px;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 5px;
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        .table-content {
          width: 100%;
          border-radius: 10px;
          border-spacing: 0;
          border-collapse: separate;
          border: 1px solid #efefef;
          border-top: 0;
          overflow: hidden;

          & th:not(:last-child),
          & td:not(:last-child) {
            border-right: 1px solid #dddddd;
          }

          & > thead > tr:not(:last-child) > th,
          & > thead > tr:not(:last-child) > td,
          & > tbody > tr:not(:last-child) > th,
          & > tbody > tr:not(:last-child) > td,
          & > tfoot > tr:not(:last-child) > th,
          & > tfoot > tr:not(:last-child) > td,
          & > tr:not(:last-child) > td,
          & > tr:not(:last-child) > th,
          & > thead:not(:last-child),
          & > tbody:not(:last-child),
          & > tfoot:not(:last-child) {
            border-bottom: 1px solid #efefef;
          }

          .table-header {
            background: #eeeeee;
            border-radius: 10px 10px 0px 0px;

            th {
              padding: 1em;
              text-align: center;
              font-style: normal;
              font-weight: 700;
              font-size: 14px;
              line-height: 20px;
              color: #303c54;
              border-bottom: 0 !important;
            }
          }

          .table-body {
            th {
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #303c54;
              border: 1px solid #efefef;
              vertical-align: baseline;
            }

            td {
              padding: 0.7em 0;
              height: 45px;
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #303c54;
              border: 1px solid #efefef;
              vertical-align: baseline;
              text-align: center;

              ul {
                list-style: none;
                margin: 0;
                width: 100%;
                padding: 0;

                li:first-child {
                  margin-bottom: 5px;
                }
              }
            }
          }
        }
      }

      .table-title {
        color: #303c54;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
      }
    }

    .modal-content-remind {
      // max-width: 440px;
      margin: 0 auto;

      .remind-note {
        .remind-employee {
          font-weight: bold;
          text-align: center;
        }
      }

      .table-modal {
        width: 100%;
        max-height: 245px;
        overflow: auto;

        &::-webkit-scrollbar {
          width: 10px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
          background: #eeeeee;
          border-radius: 0 5px 5px 0px;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 5px;
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        .table-content {
          width: 100%;
          border-radius: 10px;
          border-spacing: 0;
          border-collapse: separate;
          border: 1px solid #efefef;
          border-top: 0;
          overflow: hidden;

          & th:not(:last-child),
          & td:not(:last-child) {
            border-right: 1px solid #dddddd;
          }

          & > thead > tr:not(:last-child) > th,
          & > thead > tr:not(:last-child) > td,
          & > tbody > tr:not(:last-child) > th,
          & > tbody > tr:not(:last-child) > td,
          & > tfoot > tr:not(:last-child) > th,
          & > tfoot > tr:not(:last-child) > td,
          & > tr:not(:last-child) > td,
          & > tr:not(:last-child) > th,
          & > thead:not(:last-child),
          & > tbody:not(:last-child),
          & > tfoot:not(:last-child) {
            border-bottom: 1px solid #efefef;
          }

          .table-header {
            background: #eeeeee;
            border-radius: 10px 10px 0px 0px;

            th {
              padding: 1em;
              text-align: center;
              font-style: normal;
              font-weight: 700;
              font-size: 14px;
              line-height: 20px;
              color: #303c54;
              border-bottom: 0 !important;
            }
          }

          .table-body {
            th {
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #303c54;
              border: 1px solid #efefef;
              vertical-align: baseline;
            }

            td {
              padding: 0.7em 0;
              height: 45px;
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #303c54;
              border: 1px solid #efefef;
              vertical-align: baseline;
              text-align: center;

              ul {
                list-style: none;
                margin: 0;
                width: 100%;
                padding: 0;

                li:first-child {
                  margin-bottom: 5px;
                }
              }

              .btn-group {
                display: flex;
                gap: 6px;
                justify-content: center;

                .btn-detail {
                  color: #3488eb;
                  cursor: pointer;
                }

                .btn-remind {
                  color: #17a896;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }

      .table-title {
        color: #303c54;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
      }
    }
  }
}

.remind-modal {
  .ant-modal-body {
    padding: 20px;
    max-width: 500px;
    width: 100%;
    margin: 0 auto;

    .modal-content-wrapper {
      border: none !important;

      .modal-btn {
        align-items: center;
        display: flex;
        justify-content: space-between;

        .modal-select {
          border-radius: 10px;
          .ant-select-selection--single {
            border-radius: 10px;
          }
        }

        .footer-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          max-width: 140px;
          width: 100%;
          font-weight: 700;
          font-size: 14px;
          border-radius: 10px;
          border: unset;
          height: 40px;
        }
        .confirm-btn {
          background: #3d4cdc;
          color: #ffffff;
        }
      }

      .table-modal-wrapper {
        border: 1px solid #dddddd;
        border-radius: 10px;

        .table--header {
          background: #eeeeee;
          overflow-y: scroll;
          border-top-left-radius: 9px;
          border-top-right-radius: 9px;
          &::-webkit-scrollbar {
            width: 4px;
            color: transparent;
          }

          .table-fixed {
            width: 100%;

            & th:not(:last-child),
            & td:not(:last-child) {
              border-right: 1px solid #dddddd;
            }

            .table-header-fixed {
              tr {
                th {
                  background: #eeeeee;
                  padding: 1em;
                  text-align: center;
                  font-style: normal;
                  font-weight: 700;
                  font-size: 14px;
                  line-height: 20px;
                  color: #303c54;
                }
              }
            }
          }
        }
        .table--body {
          border-top: 1px solid #dddddd;
          max-height: 300px;
          overflow-y: scroll;
          &::-webkit-scrollbar {
            width: 4px;
          }

          /* Track */
          &::-webkit-scrollbar-track {
            background: #eeeeee;
            border-radius: 0 5px 5px 0px;
          }

          /* Handle */
          &::-webkit-scrollbar-thumb {
            background: #ccc;
            border-radius: 5px;
          }

          /* Handle on hover */
          &::-webkit-scrollbar-thumb:hover {
            background: #555;
          }
          .table-fixed {
            width: 100%;

            & th:not(:last-child),
            & td:not(:last-child) {
              border-right: 1px solid #dddddd;
            }

            & > thead > tr:not(:last-child) > th,
            & > thead > tr:not(:last-child) > td,
            & > tbody > tr:not(:last-child) > th,
            & > tbody > tr:not(:last-child) > td,
            & > tfoot > tr:not(:last-child) > th,
            & > tfoot > tr:not(:last-child) > td,
            & > tr:not(:last-child) > td,
            & > tr:not(:last-child) > th,
            & > thead:not(:last-child),
            & > tbody:not(:last-child),
            & > tfoot:not(:last-child) {
              border-bottom: 1px solid #efefef;
            }
            .table-body-fixed {
              tr {
                td {
                  padding: 0.7em 0;
                  height: 45px;
                  font-style: normal;
                  font-weight: 400;
                  font-size: 14px;
                  line-height: 20px;
                  color: #303c54;
                  border: 1px solid #efefef;
                  vertical-align: baseline;
                  text-align: center;

                  .text-success {
                    color: #17a896;
                  }

                  .text-fail {
                    color: #f03d3e;
                  }
                }
              }
            }
          }
        }
      }

      .message-not-submit-success {
        color: #303c54;
        font-weight: 400;
      }

      .table-modal {
        width: 100%;
        max-height: 245px;
        overflow: auto;

        &::-webkit-scrollbar {
          width: 10px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
          background: #eeeeee;
          border-radius: 0 5px 5px 0px;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 5px;
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        .table-content {
          width: 100%;
          border-radius: 10px;
          border-spacing: 0;
          border-collapse: separate;
          border: 1px solid #efefef;
          border-top: 0;
          overflow: hidden;

          & th:not(:last-child),
          & td:not(:last-child) {
            border-right: 1px solid #dddddd;
          }

          & > thead > tr:not(:last-child) > th,
          & > thead > tr:not(:last-child) > td,
          & > tbody > tr:not(:last-child) > th,
          & > tbody > tr:not(:last-child) > td,
          & > tfoot > tr:not(:last-child) > th,
          & > tfoot > tr:not(:last-child) > td,
          & > tr:not(:last-child) > td,
          & > tr:not(:last-child) > th,
          & > thead:not(:last-child),
          & > tbody:not(:last-child),
          & > tfoot:not(:last-child) {
            border-bottom: 1px solid #efefef;
          }

          .table-header {
            background: #eeeeee;
            border-radius: 10px 10px 0px 0px;

            th {
              padding: 1em;
              text-align: center;
              font-style: normal;
              font-weight: 700;
              font-size: 14px;
              line-height: 20px;
              color: #303c54;
              border-bottom: 0 !important;
            }
          }

          .table-body {
            th {
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #303c54;
              border: 1px solid #efefef;
              vertical-align: baseline;
            }

            td {
              padding: 0.7em 0;
              height: 45px;
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #303c54;
              border: 1px solid #efefef;
              vertical-align: baseline;
              text-align: center;

              ul {
                list-style: none;
                margin: 0;
                width: 100%;
                padding: 0;

                li:first-child {
                  margin-bottom: 5px;
                }
              }
            }
          }
        }
      }

      .table-title {
        color: #303c54;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
      }
    }

    .modal-content-remind {
      // max-width: 440px;
      margin: 0 auto;

      .remind-note {
        .remind-employee {
          font-weight: bold;
          text-align: center;
        }
      }

      .table-modal {
        width: 100%;
        max-height: 245px;
        overflow: auto;

        &::-webkit-scrollbar {
          width: 10px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
          background: #eeeeee;
          border-radius: 0 5px 5px 0px;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 5px;
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        .table-content {
          width: 100%;
          border-radius: 10px;
          border-spacing: 0;
          border-collapse: separate;
          border: 1px solid #efefef;
          border-top: 0;
          overflow: hidden;

          & th:not(:last-child),
          & td:not(:last-child) {
            border-right: 1px solid #dddddd;
          }

          & > thead > tr:not(:last-child) > th,
          & > thead > tr:not(:last-child) > td,
          & > tbody > tr:not(:last-child) > th,
          & > tbody > tr:not(:last-child) > td,
          & > tfoot > tr:not(:last-child) > th,
          & > tfoot > tr:not(:last-child) > td,
          & > tr:not(:last-child) > td,
          & > tr:not(:last-child) > th,
          & > thead:not(:last-child),
          & > tbody:not(:last-child),
          & > tfoot:not(:last-child) {
            border-bottom: 1px solid #efefef;
          }

          .table-header {
            background: #eeeeee;
            border-radius: 10px 10px 0px 0px;

            th {
              padding: 1em;
              text-align: center;
              font-style: normal;
              font-weight: 700;
              font-size: 14px;
              line-height: 20px;
              color: #303c54;
              border-bottom: 0 !important;
            }
          }

          .table-body {
            th {
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #303c54;
              border: 1px solid #efefef;
              vertical-align: baseline;
            }

            td {
              padding: 0.7em 0;
              height: 45px;
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #303c54;
              border: 1px solid #efefef;
              vertical-align: baseline;
              text-align: center;

              ul {
                list-style: none;
                margin: 0;
                width: 100%;
                padding: 0;

                li:first-child {
                  margin-bottom: 5px;
                }
              }

              .btn-group {
                display: flex;
                gap: 6px;
                justify-content: center;

                .btn-detail {
                  color: #3488eb;
                  cursor: pointer;
                }

                .btn-remind {
                  color: #17a896;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }

      .table-title {
        color: #303c54;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.time-sheet-submit {
  margin: 12px -6px 0 -6px;
}

.table-ecs-container {
  .table-content {
    min-width: 1130px;
    width: 100%;
    border-radius: 10px;
    border-spacing: 0;
    border-collapse: separate;
    border: 1px solid #efefef;
    border-top: 0;
    overflow: hidden;

    & th:not(:last-child),
    & td:not(:last-child) {
      border-right: 1px solid #efefef;
    }

    & > thead > tr:not(:last-child) > th,
    & > thead > tr:not(:last-child) > td,
    & > tbody > tr:not(:last-child) > th,
    & > tbody > tr:not(:last-child) > td,
    & > tfoot > tr:not(:last-child) > th,
    & > tfoot > tr:not(:last-child) > td,
    & > tr:not(:last-child) > td,
    & > tr:not(:last-child) > th,
    & > thead:not(:last-child),
    & > tbody:not(:last-child),
    & > tfoot:not(:last-child) {
      border-bottom: 1px solid #efefef;
    }

    .table-header {
      background: #3488eb;
      border-radius: 10px 10px 0px 0px;

      th {
        padding: 1em;
        text-align: center;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: #ffffff;
        border-bottom: 0 !important;
      }
    }

    .table-body {
      th {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #303c54;
        border: 1px solid #efefef;
        vertical-align: baseline;
      }

      td {
        padding: 0.7em 0;
        height: 45px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #303c54;
        border: 1px solid #efefef;
        vertical-align: baseline;
        text-align: center;

        ul {
          list-style: none;
          margin: 0;
          width: 100%;
          padding: 0;

          li:first-child {
            margin-bottom: 5px;
          }
        }

        .btn-outline-send {
          color: #17a896;
          border: 1px solid #17a896;
        }

        .btn-outline-send:hover {
          color: #ffffff;
          background: #17a896;
        }

        .btn-outline-detail {
          color: #3488eb;
          border: 1px solid #3488eb;
        }

        .btn-outline-detail:hover {
          color: #ffffff;
          background: #3488eb;
          border: 1px solid #3488eb;
        }

        .btn-group {
          display: flex;
          gap: 6px;
          justify-content: center;

          .btn-detail {
            color: #3488eb;
            cursor: pointer;
          }

          .btn-remind {
            color: #17a896;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.card {
  border: unset;
  border-radius: unset;

  &-body {
    padding: 10px 24px 0 24px;
  }
}

.filter {
  margin: -2rem -24px 0 -24px;
  padding: 19px 24px;

  &_title {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #3d4cdc;
  }

  &_hr {
    width: 100%;
    height: 1px;
    background-color: #eaeaea;
    margin: 19px 0;
  }

  &_month {
    //max-width: 242px;

    &__title {
      font-size: 14px;
      line-height: 17px;
      color: #303c54;
      font-weight: 500;
      margin-bottom: 8px;
    }
  }
}

@media only screen and (max-device-width: 1024px) {
  .filter {
    margin-left: -10px;
    margin-right: -10px;
  }
}

.table-list {
  margin: 12px -24px 0 -24px;
}

.required,
.error-required {
  color: #dc1313;
  font-size: 13px;
}

.btn-search-timesheet {
  /* background-color: #b5dbf2; */
  margin-top: 25px;
  height: 40px;
  width: 100%;
  max-width: 210px;
  background: #3d4cdc;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
}
</style>

<style lang="scss" scoped>
.time-sheet-submit {
  .filter-title {
    //margin: 0 -15px 19px;
    //padding-bottom: 19px;
    //border-bottom: 1px solid #EAEAEA;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #3d4cdc;
  }

  .option-table {
    padding: 9px 0 19px 0;

    .page-title {
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      color: #3d4cdc;
    }
  }
}
</style>
